import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetStockDetailsQuery } from '../slices/stocksApiSlice';

const StockScreen = () => {
  const { id: stockId } = useParams();

  const { data: stock, refetch, isLoading, error } = useGetStockDetailsQuery(stockId);

  useEffect(() => {
    if (!stock) {
      refetch();
    }
  }, [stock, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Stock {stock?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Customer Details</h2>
              <p>
                <strong>Name: </strong> {stock?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {stock?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {stock?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {stock?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {stock?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Stock Note</h2>
              <p>{stock?.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Stock Items</h2>
              {stock?.stockItems?.length === 0 ? (
                <Message>This stock has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {stock?.stockItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = D
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Stock Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{stock?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total</Col>
                  <Col>D{stock?.totalPrice || 0}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{stock?.status || 'N/A'}</Col>
                  <Col>{stock?.username || 'No user name provided'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default StockScreen;